export const LoanDetails = ({ title, children }) => (
  <div>
    <div className="font-bold text-sm">{title}</div>
    <div>{children}</div>
  </div>
);
